var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loadingDetail
    ? _c(
        "div",
        { staticClass: "eu-pa_6 eu-align_center" },
        [_c("emd-loader", { attrs: { type: "_invert" } })],
        1
      )
    : _c("div", [
        _c("div", { staticClass: "el-section" }, [
          _c("div", { staticClass: "emd-container _highlight_header" }, [
            _c("div", { staticClass: "emd-container__header" }, [
              _c("h2", { staticClass: "emd-text _size_section" }, [
                _vm._v(" " + _vm._s(_vm.$t("webhook.request.payload")) + " "),
              ]),
            ]),
            _c("div", { staticClass: "emd-container__content" }, [
              _c("div", { staticClass: "emd-panel" }, [
                _c("div", { staticClass: "emd-panel__section" }, [
                  _c("div", { staticClass: "el-chunk" }, [
                    _c("pre", [_vm._v(_vm._s(_vm.webhook.request || "-"))]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }